import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  :first-child {
    display: block;
  }
`
